import { useTranslation } from 'react-i18next';

export function AuthPromoPane() {
  const { t } = useTranslation();
  return (
    <div className="relative hidden flex-col justify-between overflow-hidden bg-accent p-12 text-fg-inv nav:flex">
      <div className="text-xs font-semibold uppercase tracking-[0.16em]">{t('auth.promo.kicker')}</div>
      <div className="max-w-[520px] font-serif text-[56px] font-medium leading-[1.05] tracking-[-0.02em]">
        {t('auth.promo.quotePart1')} <em className="font-medium italic">{t('auth.promo.quotePart1Em')}</em>.
        <br />
        {t('auth.promo.quotePart2')} <em className="font-medium italic">{t('auth.promo.quotePart2Em')}</em>.
      </div>
      <div className="text-xs font-medium uppercase tracking-[0.14em]">{t('auth.promo.footer')}</div>
    </div>
  );
}
